var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.50446 4.99047L5.6589 1.80001C6.67303 0.796982 5.19288 -0.643788 4.24235 0.31348L0.283395 4.31416C-0.094465 4.69437 -0.094465 5.30473 0.283395 5.68494L4.24235 9.68562C5.19288 10.6429 6.67303 9.20176 5.6589 8.19907L2.50446 5.00863C2.49638 5.00055 2.49638 4.99855 2.50446 4.99047Z",
    fill: "#196CA7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.42d8d32bcad8242d39982cc22ac34ee2.svg";
export { ForwardRef as ReactComponent };